import type { StaticImageData } from "next/image";
import React from "react";
import { useTranslation } from "react-i18next";

import Tooltip from "@/components/editor/tooltip/tooltip-component";

export type SettingTitleWrapperProps = {
  title?: string;
  children?: React.ReactNode;
  tooltip?: {
    heading?: string;
    description: string;
    image: StaticImageData;
  };
};

export default function SettingsTitleWrapper(props: SettingTitleWrapperProps) {
  const { t } = useTranslation();
  const { title, children, tooltip } = props;
  return (
    <>
      {title && (
        <div className="mb-4 flex items-center">
          <h2 className="mr-2 text-sm leading-6" data-testid="component-name">
            {title}
          </h2>
          {tooltip && (
            <Tooltip
              heading={
                tooltip.heading || t("preference-panel.import-event-data")
              }
              description={tooltip.description}
              image={tooltip.image}
            />
          )}
        </div>
      )}
      {children}
    </>
  );
}
